exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group-toggle-custom.btn-group-toggle .btn {\n  font-size: 0.75rem !important;\n  padding: 0.4rem 0.5rem;\n  line-height: 1; }\n\n.btn-group-toggle-custom.btn-group-toggle .btn-default {\n  border: 1px solid #007bff;\n  background: #ffffff; }\n", ""]);

// exports
